import React from 'react';
import _debounce from 'debounce';
import hoistNonReactStatic from 'hoist-non-react-statics';
import getDisplayName from 'recompose/getDisplayName';

const noop = () => {};

const withNotifyScroll = ({ debounce = 300 }) => ComponentToWrap => {
  const WithNotifyScroll = props => {
    const { onScrollChange = noop, ...restProps } = props;

    const onScrollDebounced = _debounce(onScrollChange, debounce);

    const onScroll = ({ target }) =>
      onScrollDebounced({
        scrollTop:
          target.scrollTop ||
          // for global scroll events
          (target.scrollingElement && target.scrollingElement.scrollTop) ||
          (target.documentElement && target.documentElement.scrollTop),
      });

    return <ComponentToWrap onScroll={onScroll} {...restProps} />;
  };

  WithNotifyScroll.displayName = `withNotifyScroll(${getDisplayName(
    ComponentToWrap,
  )})`;

  hoistNonReactStatic(WithNotifyScroll, ComponentToWrap);

  return WithNotifyScroll;
};

export default withNotifyScroll;
